export default __webpack_public_path__ + "static/picto_manuels-white-48170a01cd15c35d42223896f8cd7e80.png";